// Dispatched by the Alpine homepage tabs when a visitor switches to the specialist search.
export const SPECIALIST_CONSULTATIONS_OPENED_EVENT =
  "specialist-consultations-opened";
